import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowExpand02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.648 2.4h6.951m0 0v6.952m0-6.952-6.951 6.952M9.352 21.6H2.401m0 0v-6.952m0 6.952 7.2-7.2m11.999.248v6.951m0 0h-6.952m6.952 0-6.952-6.951M2.4 9.352V2.401m0 0h6.952M2.4 2.4l7.2 7.2"
    />
  </svg>
);
export default SvgArrowExpand02;
